import React from 'react'

export const DetailPage = () => {
    return (
        <div>
            <h1>Detail Page</h1>
        </div>
    )
}